import { render, staticRenderFns } from "./JitsiSetting.vue?vue&type=template&id=73dd5040&"
import script from "./JitsiSetting.vue?vue&type=script&lang=js&"
export * from "./JitsiSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports